import axios from "axios";
import Env from "/env";

/**
 * Клиент сервиса analytics-hub. Отдельный от adminHttp, потому что сервис
 * отвечает по-своему: 403 — «токен живой, но не админский», а не повод для
 * общего тоста, 202 — «отчёт ещё собирается». Ошибки разбирает страница.
 *
 * Сервис стоит за Caddy сайта под /analytics-api. Адрес выводится из API_URL,
 * как у сокета: прод-сборка с захардкоженным тестовым адресом читала бы
 * тестовые цифры.
 */
const SITE_BY_API_HOST = {
    'backendtest.bigplay.gg': 'https://front.bigplay.gg',
    'core.bigplay.gg': 'https://bigplay.gg',
}

export function resolveAnalyticsUrl(env = Env) {
    if (env.ANALYTICS_URL) return String(env.ANALYTICS_URL).replace(/\/+$/, '')

    let host = ''
    try {
        host = new URL(env.API_URL).host
    } catch (e) {
        host = ''
    }
    const site = SITE_BY_API_HOST[host] || SITE_BY_API_HOST['backendtest.bigplay.gg']

    return `${site}/analytics-api`
}

const analyticsHttp = axios.create({
    baseURL: resolveAnalyticsUrl(),
    timeout: 20000,
})

analyticsHttp.interceptors.request.use((config) => {
    const token = localStorage.getItem('token')
    if (token) config.headers['Authorization'] = `Bearer ${token}`
    return config
})

// 401 значит то же, что и у основного бэка: токен мёртвый, сервис проверяет
// его там же. Остальное — дело страницы.
analyticsHttp.interceptors.response.use(null, (e) => {
    if (e?.response?.status === 401 && window.location.pathname !== '/auth') {
        localStorage.clear()
        window.location.href = '/auth'
    }
    return Promise.reject(e)
})

export default analyticsHttp
